module.exports = __webpack_public_path__ + "static/media/logo-undervisningsministeriet.837078d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/img/logo-undervisningsministeriet.png
// module id = 1485
// module chunks = 0